export default __webpack_public_path__ + "static/media/verwaltung-messmittel-und-elektrowerkzeuge.f4fa5155.webp";